module.exports = "/assets/38a240e4835ad64f3f7acabeda752d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5H.png
// module id = 1059
// module chunks = 0